import PasswordResetForm from "../../../components/PasswordResetForm/PasswordResetForm";

const PasswordReset = () => {
  return <PasswordResetForm />;
};

export default PasswordReset;
